var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-progress-bar"
  }, [_c('div', {
    staticClass: "activity-progress-bar-background",
    style: {
      width: ((_vm.progressPercentage) + "%")
    }
  }), _c('div', {
    staticClass: "activity-progress-bar-content"
  }, [_vm._v(_vm._s(_vm.currentActivity) + " of " + _vm._s(_vm.totalActivities))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }